<div
  class="entry highlighted--color--{{ highlightedColor }}"
  [class.entry--selected]="isSelected"
  [class.entry--disabled]="disabled"
  [class.entry--compact]="compact">
  <eop-icon
    [identifier]="entry?.icon"
    [tooltip]="entry?.tooltip"
    [tooltipPosition]="'above'"
    [clickable]="false"
    [size]="IconSize.NORMAL"
    [color]="IconColor.NORMAL"></eop-icon>
  <div class="entry-container">
    @if (compact) {
      <div class="body-l entry-label--crop">{{ entry?.label }}</div>
    } @else {
      <div class="body-l entry-label">{{ entry?.label }}</div>
    }
    @if (!compact) {
      @for (additionalEntry of additionalEntries; track $index) {
        @if (additionalEntry.label) {
          <div class="inner-entry">
            <eop-icon
              [identifier]="additionalEntry.icon"
              [tooltip]="additionalEntry.tooltip"
              [tooltipPosition]="'above'"
              [clickable]="false"
              [size]="IconSize.SMALL"
              [color]="IconColor.NORMAL"></eop-icon>
            <div
              class="body-m entry-label"
              [eopDigitsCrop]="additionalEntry.label"
              [totalDigits]="20"></div>
          </div>
        }
      }
    }
  </div>
</div>
